import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { Modal } from "bootstrap";
import ScheduleChkEmployeeTimeline from "./ScheduleChkEmployeeTimeline";
import ScheduleChkEmployeeWeek from "./ScheduleChkEmployeeWeek";
import ScheduleChkDirectorAssignPanel from "./ScheduleChkDirectorAssignPanel";
import ScheduleChkTemplateAssignPanel from "./ScheduleChkTemplateAssignPanel";
import ScheduleChkSummary from "./ScheduleChkSummary";
import ScheduleChkApprove from "./ScheduleChkApprove";
import ScheduleChkMore from "./ScheduleChkMore";
import ScheduleSelectDock from "../ScheduleSelectDock";
import { usersRestaurantCHK, getUser } from "../../api/users";
import { Me } from "../../api/users";
import { PostGet } from "../../api/post";
import {
  addShift,
  addOpenShifts,
  addInternShifts,
  DeleteShift,
  DeleteShifts,
} from "../../api/shift";
import { OpentypeShiftGet } from "../../api/type_shift";
import { GetRestaurants } from "../../api/restaurant";
import {
  getSchedule,
  GetScheduleDays,
  GetScheduleAboutShifts,
} from "../../api/schedule_chk";

import { FreeTS } from "../../api/template_shift";
import { GetApprove } from "../../api/approved_chk";
import { ApprovedStatusId, MNGLevel } from "../../constants";
import { createServiceNote } from "../../api/service_note";
import {
  dayFactHours,
  formatChkHours,
  hoursByEmployeeFromShifts,
} from "./chkHours";

const DAY_LABELS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

const ScheduleChk = ({ token }) => {
  const [accessLevelUser, setAccessLevelUser] = useState();
  const [currentUser, setCurrentUser] = useState();

  const [arrayDate, setArrayDate] = useState(
    getFormattedWeekDates(new Date().toISOString().split("T")[0]),
  );

  // DAY
  const [selectedDayUser, setSelectedDayUser] = useState(null);
  const [selectedWeekday, setSelectedWeekday] = useState(null);
  const [selectedShiftDay, setSelectedShiftDay] = useState(null);
  const [showAddFromDay, setShowAddFromDay] = useState(null);
  const [selectedTypeShift, setSelectedTypeShift] = useState(0);
  const [modalMessageDay, setModalMessageDay] = useState("");
  const [dataScheduleDays, setDataScheduleDays] = useState(null);
  const [selectedInternUser, setSelectedInternUser] = useState(0);
  const [dayModalTab, setDayModalTab] = useState("status");
  const [dayModalStartDate, setDayModalStartDate] = useState("");
  const [dayModalEndDate, setDayModalEndDate] = useState("");
  const [dayModalCreating, setDayModalCreating] = useState(false);
  const [selectMode, setSelectMode] = useState(false);
  const [selectedShifts, setSelectedShifts] = useState({});
  const [confirmBulkDelete, setConfirmBulkDelete] = useState(false);
  const [bulkDeleting, setBulkDeleting] = useState(false);
  const [bulkMessage, setBulkMessage] = useState(null);
  // EndDAY

  // Grafic
  const [graficScheduleTables, setGraficSchedulTables] = useState([]);
  const [dataGraficSchedule, setDataGraficSchedule] = useState(null);
  const [selectedTemplateShift, setSelectedTemplateShift] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [selectedDateGrafic, setSelectedDateGrafic] = useState(null);
  const [showAddFormGrafic, setAddFormGrafic] = useState(false);
  const [selectedGraficUser, setSelectedGraficUser] = useState(0);
  const [modalMessageGrafic, setModalMessageGrafic] = useState("");
  const [graficModalTab, setGraficModalTab] = useState("create");
  const [serviceNoteComment, setServiceNoteComment] = useState("");
  const [replaceEmployeeId, setReplaceEmployeeId] = useState(0);
  const [swapTemplateShiftId, setSwapTemplateShiftId] = useState(0);

  // EndGrafic

  // AboutShift

  const [dataAboutShift, setDataAboutShift] = useState(null);

  // EndAboutShift

  const [openTypeShift, setOpenTypeShift] = useState([]);
  const [loadScheduleDay, setLoadScheduleDay] = useState(false);
  const [userModal, setUserModal] = useState([]);

  const [nameOpenShift, setNameOpenShift] = useState("");
  //////////////
  const [startDate, setStartDate] = useState(
    getWeekRange(new Date().toISOString().split("T")[0])["monday"],
  );
  const [endDate, setEndDate] = useState(
    getWeekRange(new Date().toISOString().split("T")[0])["sunday"],
  );
  const [loadGraficTables, setLoadGraficTables] = useState(null);

  ///////////

  const [dataApprove, setDataApprove] = useState();

  ///
  const [restaurants, setRestaurants] = useState([]);
  const [dataFreeTS, setDataFreeTS] = useState([]);
  const [selectedFreeTS, setSelectedFreeTS] = useState(0);

  const [activeTab, setActiveTab] = useState("days");
  const [graficViewMode, setGraficViewMode] = useState("employees");
  const [selectedDirectorEmployeeId, setSelectedDirectorEmployeeId] =
    useState(null);
  const [selectedDirectorTemplateId, setSelectedDirectorTemplateId] =
    useState(null);
  const [assignMessage, setAssignMessage] = useState(null);
  const [weekTemplatePanelOpen, setWeekTemplatePanelOpen] = useState(true);
  const [weekFullscreen, setWeekFullscreen] = useState(false);
  const [weekReplacePrompt, setWeekReplacePrompt] = useState(null);
  const [isLoadingDays, setIsLoadingDays] = useState(false);
  const [isLoadingGrafic, setIsLoadingGrafic] = useState(false);
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [weekPickerDate, setWeekPickerDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const loadTypeShift = async () => {
    try {
      const data = await GetRestaurants(token, 1, 50);
      setRestaurants(data.data);
      const response = await OpentypeShiftGet(token);
      const OpenTypeShiftMap = Object.fromEntries(
        response.map((shift) => [shift.id, shift.name]),
      );
      setNameOpenShift(OpenTypeShiftMap);
      setOpenTypeShift(response);
      const nowUser = await Me(token);
      setCurrentUser(nowUser);
      const post = await PostGet(token, nowUser.post_id);
      setAccessLevelUser(post.access_level);

      const usersRestaurantNow = await usersRestaurantCHK(
        token,
        nowUser.restaurant_id,
      );
      setUserModal(usersRestaurantNow);
    } catch (err) {
      console.error(err);
    }
  };

  const dataGraficScheduleRef = useRef(dataGraficSchedule);
  const dataScheduleDaysRef = useRef(dataScheduleDays);
  const dataAboutShiftRef = useRef(dataAboutShift);
  const selectedDirectorEmployeeRef = useRef(selectedDirectorEmployeeId);
  const selectedDirectorTemplateRef = useRef(selectedDirectorTemplateId);
  const assignBusyRef = useRef(false);
  const canManageScheduleRef = useRef(false);
  const useServiceNoteFlowRef = useRef(false);
  const graficBoardRef = useRef(null);
  const weekWorkspaceRef = useRef(null);

  useEffect(() => {
    dataGraficScheduleRef.current = dataGraficSchedule;
  }, [dataGraficSchedule]);

  useEffect(() => {
    dataScheduleDaysRef.current = dataScheduleDays;
  }, [dataScheduleDays]);

  useEffect(() => {
    dataAboutShiftRef.current = dataAboutShift;
  }, [dataAboutShift]);

  useEffect(() => {
    selectedDirectorEmployeeRef.current = selectedDirectorEmployeeId;
  }, [selectedDirectorEmployeeId]);

  useEffect(() => {
    selectedDirectorTemplateRef.current = selectedDirectorTemplateId;
  }, [selectedDirectorTemplateId]);

  useEffect(() => {
    const onFullscreenChange = () => {
      const el = weekWorkspaceRef.current;
      setWeekFullscreen(Boolean(el && document.fullscreenElement === el));
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
    };
  }, []);

  useEffect(() => {
    if (!weekReplacePrompt) return undefined;
    const onKeyDown = (event) => {
      if (event.key !== "Escape") return;
      event.stopPropagation();
      setWeekReplacePrompt(null);
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [weekReplacePrompt]);

  useEffect(() => {
    if (!weekFullscreen || document.fullscreenElement) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape" && !weekReplacePrompt) {
        setWeekFullscreen(false);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [weekFullscreen, weekReplacePrompt]);

  useEffect(() => {
    loadTypeShift();
  }, [token]);

  useEffect(() => {
    if (token) {
      scheduleDay();
    }
  }, [token]);

  useEffect(() => {
    if (currentUser && dataGraficSchedule) {
      renderGrafic(dataGraficSchedule);
    }
  }, [currentUser, dataGraficSchedule, userModal]);

  function filterScheduleDaysForRestaurant(data, restaurantId) {
    if (!Array.isArray(data) || !restaurantId) return data;
    return data.filter((row) => row[7]?.restaurant_id === restaurantId);
  }

  function switchTab(tab) {
    setActiveTab(tab);
    if (tab !== "days") {
      setSelectMode(false);
      setSelectedShifts({});
      setConfirmBulkDelete(false);
    }
    if (tab === "days" && !loadScheduleDay) scheduleDay();
    if (tab === "grafic" && !loadGraficTables) graficSchedule();
    if (tab === "summary" && !dataAboutShift) loadScheduleAboutShfit();
    if (tab === "approve" && !Number.isFinite(dataApprove?.id)) loadAppored();
  }

  async function selectDateDay(event) {
    const date = event.target.value;
    setWeekPickerDate(date);
    const selectDateInput = new Date(event.target.value);
    setArrayDate(getFormattedWeekDates(selectDateInput));
    setLoadScheduleDay(false);
    setLoadGraficTables(false);
    setDataAboutShift(null);
    setDataApprove(undefined);
    setSelectMode(false);
    setSelectedShifts({});
    setConfirmBulkDelete(false);
    setBulkMessage(null);
    const dates = getWeekRange(date);

    setStartDate(dates["monday"]);
    setEndDate(dates["sunday"]);

    const weekDates = getFormattedWeekDates(selectDateInput);
    if (activeTab === "days") {
      scheduleDay(weekDates[0], weekDates.at(-1));
    } else if (activeTab === "grafic") {
      graficSchedule(dates["monday"], dates["sunday"]);
    } else if (activeTab === "summary") {
      loadScheduleAboutShfit(weekDates[0], weekDates.at(-1));
    } else if (activeTab === "approve") {
      loadAppored(weekDates[0], weekDates.at(-1));
    }
  }

  async function selectDay(event, user, weekday, show, shift) {
    const iso = arrayDate[weekday] || "";
    setSelectedDayUser(user);
    setSelectedWeekday(weekday);
    setShowAddFromDay(show);
    setSelectedShiftDay(shift);
    setModalMessageDay("");
    setDayModalTab("status");
    setDayModalStartDate(iso);
    setDayModalEndDate(iso);
    setSelectedTypeShift(0);
    setSelectedInternUser(0);
    setDayModalCreating(false);
  }

  function getDaysRows(data) {
    const filtered = filterScheduleDaysForRestaurant(
      data,
      currentUser?.restaurant_id,
    );
    if (!Array.isArray(filtered)) return [];
    return filtered.map((userShifts) => {
      const user = userShifts[7];
      const isFT = userShifts.length == 9;
      const weekShifts = [];
      for (let i = 0; i <= 6; i++) {
        weekShifts.push(userShifts[i] || []);
      }
      return (
        <tr key={`user_${user.id}`}>
          <td
            className={`schedule-chk-employee schedule-chk-sticky-col${
              selectMode ? " schedule-mng-select-head" : ""
            }`}
            title={selectMode ? "Выделить все смены сотрудника" : undefined}
            onClick={selectMode ? () => toggleEmployeeRow(user) : undefined}
          >
            <div className="employee-name">
              {user.surname} {user.name}
              {isFT && <span className="schedule-chk-ft-badge">FT</span>}
            </div>
            <small className="text-muted">{user.post_name}</small>
          </td>
          {weekShifts.map((day, key) => renderShiftDay(day, user, key))}
        </tr>
      );
    });
  }

  function canDeleteChkShift(shift) {
    if (!shift?.id) return false;
    return toIsoDate(shift.date) >= todayLocalIso();
  }

  function toggleSelectMode() {
    setSelectMode((prev) => {
      if (prev) {
        setSelectedShifts({});
        setConfirmBulkDelete(false);
        setBulkMessage(null);
        return false;
      }
      return true;
    });
  }

  function clearSelection() {
    setSelectedShifts({});
    setConfirmBulkDelete(false);
    setBulkMessage(null);
  }

  function toggleSelectedShift(shift) {
    if (!canDeleteChkShift(shift)) return;
    setSelectedShifts((prev) => {
      const next = { ...prev };
      if (next[shift.id]) {
        delete next[shift.id];
      } else {
        next[shift.id] = {
          userId: shift.employee,
          date: toIsoDate(shift.date),
        };
      }
      return next;
    });
    setConfirmBulkDelete(false);
    setBulkMessage(null);
  }

  function collectDeletableShifts(predicate) {
    const next = {};
    const filtered = filterScheduleDaysForRestaurant(
      dataScheduleDays,
      currentUser?.restaurant_id,
    );
    if (!Array.isArray(filtered)) return next;
    filtered.forEach((row) => {
      const user = row[7];
      for (let weekday = 0; weekday <= 6; weekday++) {
        (row[weekday] || []).forEach((shift) => {
          if (!predicate(shift, user, weekday)) return;
          if (!canDeleteChkShift(shift)) return;
          next[shift.id] = {
            userId: shift.employee,
            date: toIsoDate(shift.date),
          };
        });
      }
    });
    return next;
  }

  function toggleGroup(nextGroup) {
    const ids = Object.keys(nextGroup);
    if (ids.length === 0) return;
    const allSelected = ids.every((id) => selectedShifts[id]);
    setSelectedShifts((prev) => {
      if (allSelected) {
        const next = { ...prev };
        ids.forEach((id) => {
          delete next[id];
        });
        return next;
      }
      return { ...prev, ...nextGroup };
    });
    setConfirmBulkDelete(false);
    setBulkMessage(null);
  }

  function toggleDayColumn(weekday) {
    toggleGroup(
      collectDeletableShifts((_shift, _user, index) => index === weekday),
    );
  }

  function toggleEmployeeRow(user) {
    toggleGroup(
      collectDeletableShifts((_shift, row) => row.id === user.id),
    );
  }

  function getShiftCellClass(day) {
    if (day.length === 0) return "shift-cell--off";
    for (let s of day) {
      const typeId = Number(s.type_shift_id);
      if (typeId === 2) return "shift-cell--intern";
      if (typeId === 3) return "shift-cell--foreign";
      if (typeId !== 1) return "shift-cell--open";
    }
    return "shift-cell--regular";
  }

  function renderShiftDay(day, user, weekday) {
    const selectedInCell = day.some(
      (shift) => shift?.id && selectedShifts[shift.id],
    );
    const lockedInCell =
      selectMode &&
      day.length > 0 &&
      day.every((shift) => !canDeleteChkShift(shift));
    const cellClass = [
      "shift-cell",
      "text-center",
      getShiftCellClass(day),
      selectedInCell ? "is-selected" : "",
      lockedInCell ? "is-locked" : "",
    ]
      .filter(Boolean)
      .join(" ");

    const handleEmptyClick = (event) => {
      if (selectMode) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      selectDay(event, user, weekday, true, null);
      getFreeTSForDay(weekday);
    };

    const handleShiftClick = (event, shift) => {
      if (selectMode) {
        event.preventDefault();
        event.stopPropagation();
        toggleSelectedShift(shift);
        return;
      }
      selectDay(event, user, weekday, false, shift);
      getFreeTSForDay(weekday);
    };

    const modalBind = selectMode
      ? {}
      : { "data-bs-toggle": "modal", "data-bs-target": "#ScheduleDayModal" };

    const factHours = dayFactHours(user, weekday);
    const factLine =
      factHours > 0 ? (
        <div className="shift-chk-cell-fact">
          факт {formatChkHours(factHours)}
        </div>
      ) : null;

    if (day.length == 0) {
      return (
        <td key={weekday} className={cellClass}>
          <div
            className="shift-cell-clickable"
            {...modalBind}
            onClick={handleEmptyClick}
          >
            Выходной
            {factLine}
          </div>
        </td>
      );
    }

    return (
      <td key={weekday} className={cellClass}>
        {day.map((shift) => {
          let content;
          if (shift.type_shift_id == 2) {
            content = (
              <>
                Закр. за {shift.fix_employee_surname} {shift.fix_employee_name}{" "}
                {shift.start} - {shift.end} {shift.station_name}
              </>
            );
          } else if (shift.type_shift_id == 1) {
            content = `${shift.start} - ${shift.end} ${shift.station_name}`;
          } else if (shift.type_shift_id == 3) {
            content = `${shift.start} - ${shift.end} ${shift.station_name}. В ${shift.restaurant_name}`;
          } else {
            content = shift.type_shift_name;
          }
          return (
            <div
              key={shift.id}
              className="shift-cell-clickable"
              {...(!selectMode || canDeleteChkShift(shift) ? modalBind : {})}
              onClick={(event) => handleShiftClick(event, shift)}
            >
              {content}
            </div>
          );
        })}
        {factLine}
      </td>
    );
  }

  function applyCreatedToDays(scheduleDays, userId, created) {
    if (!Array.isArray(scheduleDays) || !created?.length) return scheduleDays;
    return scheduleDays.map((userShifts) => {
      const user = userShifts[7];
      if (user.id != userId) return userShifts;
      const next = [...userShifts];
      created.forEach((shift) => {
        const iso = toIsoDate(shift.date);
        const idx = arrayDate.indexOf(iso);
        if (idx < 0) return;
        const existing = next[idx] || [];
        if (existing.some((item) => item.id === shift.id)) return;
        next[idx] = [...existing, shift];
      });
      return next;
    });
  }

  function removeShiftsFromDays(scheduleDays, deletedIds) {
    if (!Array.isArray(scheduleDays) || !deletedIds?.length) return scheduleDays;
    const idSet = new Set(deletedIds);
    return scheduleDays.map((userShifts) => {
      const next = [...userShifts];
      for (let i = 0; i <= 6; i++) {
        next[i] = (next[i] || []).filter((shift) => !idSet.has(shift.id));
      }
      return next;
    });
  }

  function appendShiftsToGrafic(created) {
    if (!dataGraficSchedule || !created?.length) return;
    const updatedSchedule = {
      ...dataGraficSchedule,
      shifts: [...dataGraficSchedule.shifts, ...created],
    };
    setDataGraficSchedule(updatedSchedule);
    renderGrafic(updatedSchedule);
  }

  function removeShiftsFromGrafic(deletedIds) {
    if (!dataGraficSchedule || !deletedIds?.length) return;
    const idSet = new Set(deletedIds);
    const updatedSchedule = {
      ...dataGraficSchedule,
      shifts: dataGraficSchedule.shifts.filter((shift) => !idSet.has(shift.id)),
    };
    setDataGraficSchedule(updatedSchedule);
    renderGrafic(updatedSchedule);
  }

  function appendShiftsToAbout(created) {
    if (!dataAboutShift || !created?.length) return;
    setDataAboutShift({
      ...dataAboutShift,
      shifts: [...dataAboutShift.shifts, ...created],
    });
  }

  function removeShiftsFromAbout(deletedIds) {
    if (!dataAboutShift || !deletedIds?.length) return;
    const idSet = new Set(deletedIds);
    setDataAboutShift({
      ...dataAboutShift,
      shifts: dataAboutShift.shifts.filter((shift) => !idSet.has(shift.id)),
    });
  }

  function formatBulkCreateMessage(created, skipped) {
    const days = new Set(created.map((shift) => toIsoDate(shift.date))).size;
    const parts = [];
    if (days) {
      parts.push(days === 1 ? "Проставлен 1 день" : `Проставлено ${days} дней`);
    }
    if (skipped.length) {
      parts.push(`${skipped.length} пропущены`);
    }
    return parts.join(". ") || "Нечего проставлять";
  }

  function getDayShiftsForUser(userId, isoDate) {
    const idx = arrayDate.indexOf(isoDate);
    if (idx < 0) return null;
    const row = (dataScheduleDays || []).find((item) => item[7]?.id == userId);
    if (!row) return [];
    return row[idx] || [];
  }

  function getStatusRangePreview() {
    const startDate = dayModalStartDate;
    const endDate = dayModalEndDate || dayModalStartDate;
    const dates = eachIsoDate(startDate, endDate);
    const today = todayLocalIso();
    let free = 0;
    let busy = 0;
    let past = 0;
    let otherWeek = 0;
    dates.forEach((iso) => {
      if (iso < today) {
        past += 1;
        return;
      }
      const day = getDayShiftsForUser(selectedDayUser?.id, iso);
      if (day === null) {
        otherWeek += 1;
        return;
      }
      if (day.length) busy += 1;
      else free += 1;
    });
    return { total: dates.length, free, busy, past, otherWeek };
  }

  function getInternRangePreview() {
    const startDate = dayModalStartDate;
    const endDate = dayModalEndDate || dayModalStartDate;
    const dates = eachIsoDate(startDate, endDate);
    const today = todayLocalIso();
    const trainerId = Number(selectedInternUser);
    let free = 0;
    let blocked = 0;
    let past = 0;
    let otherWeek = 0;
    dates.forEach((iso) => {
      if (iso < today) {
        past += 1;
        return;
      }
      const internDay = getDayShiftsForUser(selectedDayUser?.id, iso);
      if (internDay === null) {
        otherWeek += 1;
        return;
      }
      const trainerDay = trainerId
        ? getDayShiftsForUser(trainerId, iso)
        : [];
      if (internDay.length || !trainerId || !(trainerDay || []).length) {
        blocked += 1;
        return;
      }
      free += 1;
    });
    return { total: dates.length, free, blocked, past, otherWeek };
  }

  function setRangeDays(days) {
    if (!dayModalStartDate) return;
    setDayModalEndDate(addDaysIso(dayModalStartDate, days - 1));
  }

  function setRangeToWeekEnd() {
    if (!dayModalStartDate) return;
    const sunday = weekSundayIso(dayModalStartDate);
    setDayModalEndDate(sunday < dayModalStartDate ? dayModalStartDate : sunday);
  }

  function getCreateButtonLabel(preview) {
    if (dayModalCreating) return "Сохранение…";
    if (preview.total <= 1) {
      return dayModalTab === "intern" ? "Закрепить" : "Записать";
    }
    const count = preview.free + preview.otherWeek;
    return `Проставить ${count || preview.total} дн.`;
  }

  function renderDayPersonCard(dateLabel) {
    if (!selectedDayUser) return null;
    return (
      <div className="schedule-mng-person">
        <span className="schedule-mng-person-mark">
          {personInitials(selectedDayUser)}
        </span>
        <div className="schedule-mng-person-copy">
          <strong>
            {selectedDayUser.surname} {selectedDayUser.name}
          </strong>
          <span>{selectedDayUser.post_name}</span>
        </div>
        {dateLabel ? (
          <em className="schedule-mng-person-meta">{dateLabel}</em>
        ) : null}
      </div>
    );
  }

  function renderDayFactDetail() {
    const factHours = dayFactHours(selectedDayUser, selectedWeekday);
    if (factHours <= 0) return null;
    return (
      <div className="schedule-mng-detail">
        <span>Факт</span>
        <strong>{formatChkHours(factHours)}</strong>
      </div>
    );
  }

  function renderDayShiftDetails(shift) {
    if (!shift) return null;
    const factDetail = renderDayFactDetail();
    if (Number(shift.type_shift_id) === 2) {
      return (
        <div className="schedule-mng-details">
          <div className="schedule-mng-detail">
            <span>Закреплён за</span>
            <strong>
              {shift.fix_employee_surname} {shift.fix_employee_name}
            </strong>
          </div>
          <div className="schedule-mng-detail">
            <span>Время</span>
            <strong>
              {shift.start} — {shift.end}
            </strong>
          </div>
          {shift.station_name ? (
            <div className="schedule-mng-detail">
              <span>Станция</span>
              <strong>{shift.station_name}</strong>
            </div>
          ) : null}
          {factDetail}
        </div>
      );
    }
    if (Number(shift.type_shift_id) === 1 || Number(shift.type_shift_id) === 3) {
      return (
        <div className="schedule-mng-details">
          <div className="schedule-mng-detail">
            <span>Время</span>
            <strong>
              {shift.start} — {shift.end}
            </strong>
          </div>
          {shift.hours ? (
            <div className="schedule-mng-detail">
              <span>Часов</span>
              <strong>{shift.hours}</strong>
            </div>
          ) : null}
          {factDetail}
          {shift.station_name ? (
            <div className="schedule-mng-detail">
              <span>Станция</span>
              <strong>{shift.station_name}</strong>
            </div>
          ) : null}
          {Number(shift.type_shift_id) === 3 && shift.restaurant_name ? (
            <div className="schedule-mng-detail">
              <span>Ресторан</span>
              <strong>{shift.restaurant_name}</strong>
            </div>
          ) : null}
        </div>
      );
    }
    return (
      <div className="schedule-mng-details">
        <div className="schedule-mng-detail">
          <span>Статус дня</span>
          <strong>
            {shift.type_shift_name ||
              nameOpenShift[shift.type_shift_id] ||
              "Статус"}
          </strong>
        </div>
        {factDetail}
      </div>
    );
  }

  function renderDayRangeFields(preview) {
    const endDate = dayModalEndDate || dayModalStartDate;
    return (
      <div className="schedule-mng-field">
        <span className="form-label">Период</span>
        <div className="schedule-mng-range">
          <label>
            С
            <input
              type="date"
              className="form-control"
              value={dayModalStartDate || ""}
              onChange={(event) => {
                const nextStart = event.target.value;
                setDayModalStartDate(nextStart);
                setDayModalEndDate(
                  !dayModalEndDate || dayModalEndDate < nextStart
                    ? nextStart
                    : dayModalEndDate,
                );
              }}
            />
          </label>
          <span>→</span>
          <label>
            По
            <input
              type="date"
              className="form-control"
              min={dayModalStartDate || undefined}
              value={endDate || ""}
              onChange={(event) => setDayModalEndDate(event.target.value)}
            />
          </label>
        </div>
        <div className="schedule-mng-range-presets">
          {[1, 3, 7, 14].map((days) => (
            <button
              key={days}
              type="button"
              className={`schedule-mng-range-chip${
                preview.total === days ? " is-active" : ""
              }`}
              onClick={() => setRangeDays(days)}
            >
              {days === 1 ? "1 день" : `${days} дн.`}
            </button>
          ))}
          <button
            type="button"
            className="schedule-mng-range-chip"
            onClick={setRangeToWeekEnd}
          >
            До конца недели
          </button>
        </div>
        {preview.total > 1 ? (
          <div className="schedule-mng-preview">
            <div>
              <strong>{preview.free + preview.otherWeek}</strong>
              <span>проставим</span>
            </div>
            <div>
              <strong>
                {preview.busy ?? preview.blocked ?? 0}
              </strong>
              <span>нельзя</span>
            </div>
            <div>
              <strong>{preview.past}</strong>
              <span>прошлые</span>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  function renderDayTemplateField() {
    return (
      <div className="schedule-mng-field">
        <label className="form-label" htmlFor="chk-day-free-ts">
          Свободный слот
        </label>
        <select
          id="chk-day-free-ts"
          className="form-select"
          value={selectedFreeTS}
          onChange={(e) => setSelectedFreeTS(e.target.value)}
        >
          <option value={0}>Не выбрано</option>
          {dataFreeTS.map((ts) => (
            <option key={ts.id} value={ts.id}>
              {ts.start} - {ts.end}. {ts.hours} ч. {ts.station_name}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="btn mt-2"
          onClick={createShiftDayByTS}
        >
          Записать на слот
        </button>
      </div>
    );
  }

  async function scheduleDay(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) {
      alert("Выберите дату!");
      return;
    }
    if (!overrideFrom && (loadScheduleDay || isLoadingDays)) return;
    setIsLoadingDays(true);
    try {
      const scheduleDays = await GetScheduleDays(token, from, to);
      setDataScheduleDays(scheduleDays);
      setLoadScheduleDay(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingDays(false);
    }
  }

  async function addShiftOpenScheduleDay() {
    if (!selectedDayUser || !dayModalStartDate) return;
    if (!Number(selectedTypeShift)) {
      setModalMessageDay(
        <p style={{ color: "red" }}>Выберите статус дня</p>,
      );
      return;
    }
    const endDate = dayModalEndDate || dayModalStartDate;
    if (endDate < dayModalStartDate) {
      setModalMessageDay(
        <p style={{ color: "red" }}>Конец периода раньше начала</p>,
      );
      return;
    }
    setDayModalCreating(true);
    try {
      const data = await addOpenShifts(
        token,
        selectedDayUser.id,
        dayModalStartDate,
        endDate,
        Number(selectedTypeShift),
      );
      if (!data || data.detail) {
        setModalMessageDay(
          <p style={{ color: "red" }}>{errorText(data, "Не удалось сохранить")}</p>,
        );
        return;
      }
      const created = Array.isArray(data.created) ? data.created : [];
      const skipped = Array.isArray(data.skipped) ? data.skipped : [];
      if (created.length) {
        const updated = applyCreatedToDays(
          dataScheduleDays,
          selectedDayUser.id,
          created,
        );
        setDataScheduleDays(updated);
        const currentIso = arrayDate[selectedWeekday];
        const createdHere = created.find(
          (shift) => toIsoDate(shift.date) === currentIso,
        );
        if (createdHere) {
          setShowAddFromDay(false);
          setSelectedShiftDay(createdHere);
        }
        const user = await getUser(token, selectedDayUser.id);
        setModalMessageDay(
          <p style={{ color: "green" }}>
            {user.surname} {user.name}: {formatBulkCreateMessage(created, skipped)}
          </p>,
        );
      } else {
        setModalMessageDay(
          <p style={{ color: "red" }}>
            {formatBulkCreateMessage(created, skipped)}
            {skipped[0]?.reason ? `. ${skipped[0].reason}` : ""}
          </p>,
        );
      }
    } catch (err) {
      console.error(err);
      setModalMessageDay(
        <p style={{ color: "red" }}>Не удалось сохранить</p>,
      );
    } finally {
      setDayModalCreating(false);
    }
  }

  async function addInternShiftScheduleDay() {
    if (!selectedDayUser || !dayModalStartDate) return;
    if (!Number(selectedInternUser)) {
      setModalMessageDay(
        <p style={{ color: "red" }}>Выберите сотрудника для закрепления</p>,
      );
      return;
    }
    const endDate = dayModalEndDate || dayModalStartDate;
    if (endDate < dayModalStartDate) {
      setModalMessageDay(
        <p style={{ color: "red" }}>Конец периода раньше начала</p>,
      );
      return;
    }
    setDayModalCreating(true);
    try {
      const data = await addInternShifts(
        token,
        selectedDayUser.id,
        Number(selectedInternUser),
        dayModalStartDate,
        endDate,
      );
      if (!data || data.detail) {
        setModalMessageDay(
          <p style={{ color: "red" }}>{errorText(data, "Не удалось сохранить")}</p>,
        );
        return;
      }
      const created = Array.isArray(data.created) ? data.created : [];
      const skipped = Array.isArray(data.skipped) ? data.skipped : [];
      if (created.length) {
        const updated = applyCreatedToDays(
          dataScheduleDays,
          selectedDayUser.id,
          created,
        );
        setDataScheduleDays(updated);
        appendShiftsToGrafic(created);
        appendShiftsToAbout(created);
        const currentIso = arrayDate[selectedWeekday];
        const createdHere = created.find(
          (shift) => toIsoDate(shift.date) === currentIso,
        );
        if (createdHere) {
          setShowAddFromDay(false);
          setSelectedShiftDay(createdHere);
        }
        const employee = await getUser(token, selectedDayUser.id);
        const fixUser = await getUser(token, Number(selectedInternUser));
        setModalMessageDay(
          <p style={{ color: "green" }}>
            {employee.surname} {employee.name} закреплен за {fixUser.surname}{" "}
            {fixUser.name}. {formatBulkCreateMessage(created, skipped)}
          </p>,
        );
      } else {
        setModalMessageDay(
          <p style={{ color: "red" }}>
            {formatBulkCreateMessage(created, skipped)}
            {skipped[0]?.reason ? `. ${skipped[0].reason}` : ""}
          </p>,
        );
      }
    } catch (err) {
      console.error(err);
      setModalMessageDay(
        <p style={{ color: "red" }}>Не удалось сохранить</p>,
      );
    } finally {
      setDayModalCreating(false);
    }
  }

  async function deleteShiftScheduleChk() {
    if (!selectedShiftDay) {
      setModalMessageDay(<p style={{ color: "red" }}>Нечего удалять!</p>);
      return;
    }

    const data = await DeleteShift(token, selectedShiftDay.id);
    if (data.detail) {
      setModalMessageDay(<p style={{ color: "red" }}> {data.detail}</p>);
      return;
    }
    await getFreeTSForDay(selectedWeekday);
    const updateDataScheduleDays = removeShiftsFromDays(dataScheduleDays, [
      selectedShiftDay.id,
    ]);
    const remaining =
      updateDataScheduleDays.find(
        (row) => row[7]?.id === selectedDayUser.id,
      )?.[selectedWeekday] || [];

    removeShiftsFromGrafic([selectedShiftDay.id]);
    removeShiftsFromAbout([selectedShiftDay.id]);
    setDataScheduleDays(updateDataScheduleDays);
    setShowAddFromDay(remaining.length === 0);
    setSelectedShiftDay(null);
    setModalMessageDay(<p style={{ color: "green" }}>Удалено!</p>);
  }

  async function deleteSelectedShifts() {
    const ids = Object.keys(selectedShifts).map(Number);
    if (ids.length === 0) return;
    setBulkDeleting(true);
    setBulkMessage(null);
    try {
      const data = await DeleteShifts(token, ids);
      if (!data || data.detail) {
        setBulkMessage({
          ok: false,
          text: errorText(data, "Не удалось удалить смены"),
        });
        return;
      }
      const deletedIds = Array.isArray(data?.deleted_ids)
        ? data.deleted_ids
        : [];
      const skipped = Array.isArray(data?.skipped) ? data.skipped : [];
      if (deletedIds.length) {
        setDataScheduleDays((prev) => removeShiftsFromDays(prev, deletedIds));
        removeShiftsFromGrafic(deletedIds);
        removeShiftsFromAbout(deletedIds);
      }
      const skippedPast = skipped.filter((item) =>
        String(item.reason || "").includes("прошл"),
      ).length;
      const otherSkipped = skipped.length - skippedPast;
      const parts = [];
      if (deletedIds.length) {
        parts.push(
          deletedIds.length === 1
            ? "Удалена 1 смена"
            : `Удалено ${deletedIds.length} смен`,
        );
      }
      if (skippedPast) {
        parts.push(`${skippedPast} с прошедшей датой пропущены`);
      }
      if (otherSkipped) {
        parts.push(`${otherSkipped} не удалось удалить`);
      }
      setBulkMessage({
        ok: deletedIds.length > 0,
        text: parts.join(". ") || "Нечего удалять",
      });
      setSelectedShifts({});
      setConfirmBulkDelete(false);
    } catch (err) {
      console.error(err);
      setBulkMessage({ ok: false, text: "Не удалось удалить смены" });
    } finally {
      setBulkDeleting(false);
    }
  }

  async function graficSchedule(overrideStart, overrideEnd) {
    const start = overrideStart ?? startDate;
    const end = overrideEnd ?? endDate;
    if (!start) {
      alert("Выберите дату!");
      return;
    }
    if (!overrideStart && (loadGraficTables || isLoadingGrafic)) return;
    setIsLoadingGrafic(true);
    try {
      const [data, approveData] = await Promise.all([
        getSchedule(token, start, end),
        GetApprove(token, start, end),
      ]);
      setDataGraficSchedule(data);
      if (Number.isFinite(approveData?.id)) {
        setDataApprove(approveData);
      }
      renderGrafic(data);
      setLoadGraficTables(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingGrafic(false);
    }
  }

  function syncShiftIntoDays(shift, scheduleDays) {
    if (!scheduleDays || !shift?.date) return scheduleDays;
    const selectedWeekday = getISODayNumber(shift.date);
    const updateDataScheduleDays = scheduleDays.map((userShifts) => {
      const user = userShifts[7];
      if (user.id == shift.employee) {
        const newUserShifts = [...userShifts];
        const existingShifts = newUserShifts[selectedWeekday] || [];
        newUserShifts[selectedWeekday] = [...existingShifts, shift];
        return newUserShifts;
      }
      return [...userShifts];
    });
    setDataScheduleDays(updateDataScheduleDays);
    return updateDataScheduleDays;
  }

  function syncShiftOutOfDays(shift, scheduleDays) {
    if (!scheduleDays || !shift?.date) return scheduleDays;
    const selectedWeekday = getISODayNumber(shift.date);
    const updateDataScheduleDays = scheduleDays.map((userShifts) => {
      const user = userShifts[7];
      if (user.id == shift.employee) {
        const newUserShifts = [...userShifts];
        const existingShifts = newUserShifts[selectedWeekday] || [];
        newUserShifts[selectedWeekday] = existingShifts.filter(
          (item) => item.id !== shift.id,
        );
        return newUserShifts;
      }
      return [...userShifts];
    });
    setDataScheduleDays(updateDataScheduleDays);
    return updateDataScheduleDays;
  }

  function syncShiftIntoAbout(shift, aboutShift) {
    if (!aboutShift) return aboutShift;
    const updatedData = {
      ...aboutShift,
      shifts: [...aboutShift.shifts, shift],
    };
    setDataAboutShift(updatedData);
    return updatedData;
  }

  function syncShiftOutOfAbout(shift, aboutShift) {
    if (!aboutShift) return aboutShift;
    const updatedData = {
      ...aboutShift,
      shifts: aboutShift.shifts.filter((item) => item.id !== shift.id),
    };
    setDataAboutShift(updatedData);
    return updatedData;
  }

  function formatShiftError(detail) {
    if (detail == null) return "Ошибка";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return detail.map((item) => item?.msg || item).join("; ");
    }
    return String(detail);
  }

  async function applyAddShift(templateShift, employeeId, schedule) {
    const newShift = await addShift(token, templateShift.id, employeeId);
    if (!newShift || newShift.detail) {
      return {
        ok: false,
        error: formatShiftError(newShift?.detail || "Не удалось добавить смену"),
        schedule,
      };
    }
    if (!schedule?.shifts) {
      return { ok: false, error: "График ещё не загружен", schedule };
    }
    const updatedSchedule = {
      ...schedule,
      shifts: [...schedule.shifts, newShift],
    };
    setDataGraficSchedule(updatedSchedule);
    dataGraficScheduleRef.current = updatedSchedule;
    renderGrafic(updatedSchedule);
    const days = syncShiftIntoDays(newShift, dataScheduleDaysRef.current);
    dataScheduleDaysRef.current = days;
    const about = syncShiftIntoAbout(newShift, dataAboutShiftRef.current);
    dataAboutShiftRef.current = about;
    return { ok: true, schedule: updatedSchedule, newShift };
  }

  async function applyDeleteShift(shift, schedule) {
    const deleteShift = await DeleteShift(token, shift.id);
    if (deleteShift?.detail) {
      return {
        ok: false,
        error: formatShiftError(deleteShift.detail),
        schedule,
      };
    }
    if (!schedule?.shifts) {
      return { ok: false, error: "График ещё не загружен", schedule };
    }
    const updatedSchedule = {
      ...schedule,
      shifts: schedule.shifts.filter((item) => item.id !== shift.id),
    };
    setDataGraficSchedule(updatedSchedule);
    dataGraficScheduleRef.current = updatedSchedule;
    renderGrafic(updatedSchedule);
    const days = syncShiftOutOfDays(shift, dataScheduleDaysRef.current);
    dataScheduleDaysRef.current = days;
    const about = syncShiftOutOfAbout(shift, dataAboutShiftRef.current);
    dataAboutShiftRef.current = about;
    return { ok: true, schedule: updatedSchedule };
  }

  async function addShiftGrafic(event) {
    if (!selectedGraficUser || selectedGraficUser === "0") {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>Не выбран сотрудник!</p>,
      );
      return;
    }

    const result = await applyAddShift(
      selectedTemplateShift,
      selectedGraficUser,
      dataGraficScheduleRef.current,
    );
    if (!result.ok) {
      setModalMessageGrafic(<p style={{ color: "red" }}>{result.error}</p>);
      return;
    }
    setModalMessageGrafic("");
    setSelectedShift(result.newShift);
    setAddFormGrafic(false);
  }

  async function deleteShiftGrafic(event) {
    if (!selectedShift) {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>Нет смены, чтобы удалить!</p>,
      );
      return;
    }
    const result = await applyDeleteShift(
      selectedShift,
      dataGraficScheduleRef.current,
    );
    if (!result.ok) {
      setModalMessageGrafic(<p style={{ color: "red" }}>{result.error}</p>);
      return;
    }
    setModalMessageGrafic("");
    setSelectedShift(null);
    setAddFormGrafic(true);
  }

  function selectFieldGrafic(templateShift, shift, date) {
    console.log("Выбранный шаблон и смена", templateShift, shift);
    setModalMessageGrafic("");
    setServiceNoteComment("");
    setReplaceEmployeeId(0);
    setSwapTemplateShiftId(0);
    if (shift) {
      setAddFormGrafic(false);
      setGraficModalTab("delete");
    } else {
      setAddFormGrafic(true);
      setGraficModalTab("create");
    }
    setSelectedTemplateShift(templateShift);
    setSelectedShift(shift);
    setSelectedDateGrafic(date);
  }

  const isScheduleTyApproved = dataApprove?.TY_status === ApprovedStatusId;
  const accessLevelNow = Number(
    accessLevelUser ??
      (typeof window !== "undefined"
        ? localStorage.getItem("access_level")
        : 0),
  );
  const canManageSchedule =
    Number.isFinite(accessLevelNow) && accessLevelNow >= MNGLevel;
  const useServiceNoteFlow = isScheduleTyApproved && canManageSchedule;
  canManageScheduleRef.current = canManageSchedule;
  useServiceNoteFlowRef.current = useServiceNoteFlow;

  const directorAssignStats = useMemo(() => {
    const hoursByEmployee = hoursByEmployeeFromShifts(
      dataGraficSchedule?.shifts,
      arrayDate,
    );
    const ftIds = new Set();
    const dayRows = Array.isArray(dataScheduleDays)
      ? dataScheduleDays
      : Object.values(dataScheduleDays || {});
    dayRows.forEach((row) => {
      if (row?.length == 9 && row[7]?.id) {
        ftIds.add(Number(row[7].id));
      }
    });
    const templates = dataGraficSchedule?.ts || [];
    const filledIds = new Set(
      (dataGraficSchedule?.shifts || []).map((shift) => shift.template_shift_id),
    );
    return {
      hoursByEmployee,
      ftIds,
      slotCount: templates.length,
      filledCount: templates.filter((ts) => filledIds.has(ts.id)).length,
    };
  }, [dataGraficSchedule, dataScheduleDays, arrayDate]);

  useEffect(() => {
    const board = graficBoardRef.current;
    if (!board) return;
    const selectedId = selectedDirectorEmployeeId;
    board.classList.toggle("is-filtering", Boolean(selectedId));
    board.querySelectorAll("tr[data-employee-id]").forEach((row) => {
      const match =
        selectedId != null &&
        Number(row.getAttribute("data-employee-id")) === Number(selectedId);
      row.classList.toggle("is-selected-employee", match);
    });
  }, [selectedDirectorEmployeeId, graficScheduleTables, graficViewMode]);

  function openGraficModal() {
    const el = document.getElementById("ScheduleGraficModal");
    if (!el) return;
    Modal.getOrCreateInstance(el).show();
  }

  async function handleStationSlotClick(templateShift, shift, date) {
    if (assignBusyRef.current) return;

    const selectedId = selectedDirectorEmployeeRef.current;
    const needsModal =
      useServiceNoteFlowRef.current ||
      !canManageScheduleRef.current ||
      !selectedId;

    if (needsModal) {
      selectFieldGrafic(templateShift, shift, date);
      openGraficModal();
      return;
    }

    assignBusyRef.current = true;
    setAssignMessage(null);
    try {
      const schedule = dataGraficScheduleRef.current;
      if (!shift) {
        const result = await applyAddShift(templateShift, selectedId, schedule);
        setAssignMessage(
          result.ok
            ? { type: "ok", text: "Смена назначена" }
            : { type: "error", text: String(result.error) },
        );
        return;
      }

      if (Number(shift.employee) === Number(selectedId)) {
        const result = await applyDeleteShift(shift, schedule);
        setAssignMessage(
          result.ok
            ? { type: "ok", text: "Смена снята" }
            : { type: "error", text: String(result.error) },
        );
        return;
      }

      const occupiedName = `${shift.user_surname || ""} ${shift.user_name || ""}`.trim();
      if (
        !window.confirm(
          occupiedName
            ? `Заменить ${occupiedName} выбранным сотрудником?`
            : "Заменить сотрудника на выбранного?",
        )
      ) {
        return;
      }

      const deleted = await applyDeleteShift(shift, schedule);
      if (!deleted.ok) {
        setAssignMessage({ type: "error", text: String(deleted.error) });
        return;
      }
      const added = await applyAddShift(
        templateShift,
        selectedId,
        deleted.schedule,
      );
      setAssignMessage(
        added.ok
          ? { type: "ok", text: "Сотрудник заменён" }
          : { type: "error", text: String(added.error) },
      );
    } catch (err) {
      console.error(err);
      setAssignMessage({ type: "error", text: "Не удалось изменить смену" });
    } finally {
      assignBusyRef.current = false;
    }
  }

  async function handleWeekEmployeeClick(employee) {
    if (assignBusyRef.current) return;

    const templateId = selectedDirectorTemplateRef.current;
    const schedule = dataGraficScheduleRef.current;
    const templateShift = (schedule?.ts || []).find(
      (ts) => Number(ts.id) === Number(templateId),
    );

    const needsModal =
      useServiceNoteFlowRef.current ||
      !canManageScheduleRef.current ||
      !templateShift;

    if (needsModal) {
      return;
    }

    const occupying = (schedule?.shifts || []).find(
      (shift) => Number(shift.template_shift_id) === Number(templateShift.id),
    );

    assignBusyRef.current = true;
    setAssignMessage(null);
    try {
      if (!occupying) {
        const result = await applyAddShift(
          templateShift,
          employee.id,
          schedule,
        );
        setAssignMessage(
          result.ok
            ? { type: "ok", text: `Смена поставлена: ${employee.name}` }
            : { type: "error", text: String(result.error) },
        );
        return;
      }

      if (Number(occupying.employee) === Number(employee.id)) {
        const result = await applyDeleteShift(occupying, schedule);
        setAssignMessage(
          result.ok
            ? { type: "ok", text: "Смена снята" }
            : { type: "error", text: String(result.error) },
        );
        return;
      }

      const occupiedName =
        `${occupying.user_surname || ""} ${occupying.user_name || ""}`.trim();
      setWeekReplacePrompt({
        templateShiftId: templateShift.id,
        occupyingShiftId: occupying.id,
        employeeId: employee.id,
        employeeName: employee.name,
        occupiedName,
      });
    } catch (err) {
      console.error(err);
      setAssignMessage({ type: "error", text: "Не удалось изменить смену" });
    } finally {
      assignBusyRef.current = false;
    }
  }

  async function confirmWeekReplace() {
    const prompt = weekReplacePrompt;
    if (!prompt || assignBusyRef.current) return;

    assignBusyRef.current = true;
    setAssignMessage(null);
    try {
      const schedule = dataGraficScheduleRef.current;
      const occupying = (schedule?.shifts || []).find(
        (shift) => shift.id === prompt.occupyingShiftId,
      );
      const templateShift = (schedule?.ts || []).find(
        (ts) => Number(ts.id) === Number(prompt.templateShiftId),
      );
      if (!occupying || !templateShift) {
        setWeekReplacePrompt(null);
        setAssignMessage({ type: "error", text: "Слот уже изменился" });
        return;
      }

      const deleted = await applyDeleteShift(occupying, schedule);
      if (!deleted.ok) {
        setAssignMessage({ type: "error", text: String(deleted.error) });
        return;
      }
      const added = await applyAddShift(
        templateShift,
        prompt.employeeId,
        deleted.schedule,
      );
      setAssignMessage(
        added.ok
          ? { type: "ok", text: "Сотрудник заменён" }
          : { type: "error", text: String(added.error) },
      );
      setWeekReplacePrompt(null);
    } catch (err) {
      console.error(err);
      setAssignMessage({ type: "error", text: "Не удалось изменить смену" });
    } finally {
      assignBusyRef.current = false;
    }
  }

  function handleWeekShiftClick(employee, shift) {
    const schedule = dataGraficScheduleRef.current;
    const templateShift = (schedule?.ts || []).find(
      (ts) => Number(ts.id) === Number(shift.template_shift_id),
    );
    if (!templateShift) return;
    selectFieldGrafic(templateShift, shift, templateShift.date);
    openGraficModal();
  }

  async function toggleWeekFullscreen() {
    const el = weekWorkspaceRef.current;
    if (!el) return;

    const nativeEl = document.fullscreenElement;
    try {
      if (nativeEl === el) {
        await document.exitFullscreen();
        return;
      }
      if (nativeEl) {
        await document.exitFullscreen();
      }
      if (el.requestFullscreen) {
        await el.requestFullscreen();
        return;
      }
    } catch (err) {
      console.error(err);
    }
    setWeekFullscreen((open) => !open);
  }

  function getSwapShiftOptions() {
    if (!dataGraficSchedule?.ts || !dataGraficSchedule?.shifts || !selectedTemplateShift) {
      return [];
    }
    return dataGraficSchedule.ts
      .filter((ts) => ts.id !== selectedTemplateShift.id)
      .map((ts) => {
        const shift = dataGraficSchedule.shifts.find(
          (s) => s.template_shift_id === ts.id,
        );
        if (!shift) return null;
        return { templateShift: ts, shift };
      })
      .filter(Boolean);
  }

  function buildShiftSnapshot(shift, templateShift) {
    return {
      shift_id: shift?.id ?? null,
      template_shift_id: templateShift?.id ?? shift?.template_shift_id,
      employee_id: shift?.employee ?? null,
      employee_name: shift
        ? `${shift.user_surname ?? ""} ${shift.user_name ?? ""}`.trim()
        : null,
      date: templateShift?.date ?? shift?.date,
      station_name: templateShift?.station_name ?? shift?.station_name,
      start: templateShift?.start ?? shift?.start,
      end: templateShift?.end ?? shift?.end,
    };
  }

  async function submitServiceNoteGrafic() {
    if (!serviceNoteComment.trim()) {
      setModalMessageGrafic(
        <p style={{ color: "red" }}>Укажите причину изменения в комментарии</p>,
      );
      return;
    }

    let operationType = null;
    let templateShiftId = selectedTemplateShift?.id ?? null;
    let secondTemplateShiftId = null;
    let payload = { snapshot: {}, comment: serviceNoteComment.trim() };

    if (graficModalTab === "create") {
      if (!selectedGraficUser || selectedGraficUser === "0") {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите сотрудника для записи</p>,
        );
        return;
      }
      operationType = "create_shift";
      const selectedEmployee = userModal.find(
        (user) => user.id === Number(selectedGraficUser),
      );
      const employeeName = selectedEmployee
        ? `${selectedEmployee.surname} ${selectedEmployee.name}`.trim()
        : null;
      payload.employee_id = Number(selectedGraficUser);
      payload.snapshot = {
        template_shift: buildShiftSnapshot(null, selectedTemplateShift),
        employee_id: Number(selectedGraficUser),
        employee_name: employeeName,
      };
    } else if (graficModalTab === "delete") {
      if (!selectedShift) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Нет смены для удаления</p>,
        );
        return;
      }
      operationType = "delete_shift";
      payload.snapshot = buildShiftSnapshot(selectedShift, selectedTemplateShift);
    } else if (graficModalTab === "replace") {
      if (!selectedShift) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Нет смены для замены сотрудника</p>,
        );
        return;
      }
      if (!replaceEmployeeId || replaceEmployeeId === "0") {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите нового сотрудника</p>,
        );
        return;
      }
      if (Number(replaceEmployeeId) === selectedShift.employee) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите другого сотрудника</p>,
        );
        return;
      }
      operationType = "replace_employee";
      const newEmployee = userModal.find(
        (user) => user.id === Number(replaceEmployeeId),
      );
      const newEmployeeName = newEmployee
        ? `${newEmployee.surname} ${newEmployee.name}`.trim()
        : null;
      payload.new_employee_id = Number(replaceEmployeeId);
      payload.snapshot = {
        shift: buildShiftSnapshot(selectedShift, selectedTemplateShift),
        new_employee_id: Number(replaceEmployeeId),
        new_employee_name: newEmployeeName,
      };
    } else if (graficModalTab === "swap") {
      if (!selectedShift) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите смену для обмена</p>,
        );
        return;
      }
      if (!swapTemplateShiftId || swapTemplateShiftId === "0") {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Выберите вторую смену для обмена</p>,
        );
        return;
      }
      const swapOption = getSwapShiftOptions().find(
        (opt) => String(opt.templateShift.id) === String(swapTemplateShiftId),
      );
      if (!swapOption) {
        setModalMessageGrafic(
          <p style={{ color: "red" }}>Вторая смена недоступна для обмена</p>,
        );
        return;
      }
      operationType = "swap_employees";
      secondTemplateShiftId = swapOption.templateShift.id;
      payload.snapshot = {
        shift_a: buildShiftSnapshot(selectedShift, selectedTemplateShift),
        shift_b: buildShiftSnapshot(swapOption.shift, swapOption.templateShift),
      };
    }

    const body = {
      start_date: startDate,
      end_date: endDate,
      comment: serviceNoteComment.trim(),
      operation: {
        operation_type: operationType,
        template_shift_id: templateShiftId,
        second_template_shift_id: secondTemplateShiftId,
        payload,
      },
    };

    const result = await createServiceNote(token, body);
    if (result.detail) {
      setModalMessageGrafic(<p style={{ color: "red" }}>{result.detail}</p>);
      return;
    }
    setModalMessageGrafic(
      <p style={{ color: "green" }}>Служебная записка отправлена на согласование</p>,
    );
  }

  async function handleGraficModalSubmit(event) {
    if (useServiceNoteFlow) {
      await submitServiceNoteGrafic();
      return;
    }
    if (graficModalTab === "create") {
      await addShiftGrafic(event);
      return;
    }
    if (graficModalTab === "delete") {
      await deleteShiftGrafic(event);
      return;
    }
    setModalMessageGrafic(
      <p style={{ color: "red" }}>
        Замена и обмен доступны после согласования расписания ТУ через служебную
        записку
      </p>,
    );
  }

  function renderGraficModalTabContent() {
    const slotInfo = selectedTemplateShift
      ? getInfoTemplateShiftGrafic(selectedTemplateShift)
      : "";
    const shiftInfo = selectedShift ? (
      <>
        <p className="mb-1">
          Сотрудник: <b>{getInfoFromShiftGrafic(selectedShift)}</b>
        </p>
        <p className="mb-0">{getInfoShiftGrafic(selectedShift)}</p>
      </>
    ) : null;

    if (graficModalTab === "create") {
      return (
        <div className="schedule-grafic-tab-panel">
          <p className="schedule-chk-modal-info text-center">{slotInfo}</p>
          <select
            className="form-select mx-auto"
            style={{ maxWidth: "400px" }}
            value={selectedGraficUser}
            onChange={(e) => setSelectedGraficUser(e.target.value)}
            disabled={!!selectedShift}
          >
            <option value="0">Выберите сотрудника для записи</option>
            {userModal.map((user) => (
              <option key={user.id} value={user.id}>
                {user.surname} {user.name}
              </option>
            ))}
          </select>
          {selectedShift && (
            <p className="text-muted small text-center mt-2">
              На этот слот уже назначена смена — используйте другую вкладку
            </p>
          )}
        </div>
      );
    }

    if (graficModalTab === "delete") {
      return (
        <div className="schedule-grafic-tab-panel schedule-chk-modal-info text-center">
          {shiftInfo || (
            <p className="text-muted">Смена не выбрана или слот пустой</p>
          )}
          {useServiceNoteFlow && selectedShift && (
            <p className="text-warning small mt-2">
              Будет создана служебная записка на удаление смены
            </p>
          )}
        </div>
      );
    }

    if (graficModalTab === "replace") {
      return (
        <div className="schedule-grafic-tab-panel">
          <div className="schedule-chk-modal-info text-center mb-3">
            {shiftInfo || (
              <p className="text-muted">Выберите занятый слот в расписании</p>
            )}
          </div>
          <select
            className="form-select mx-auto"
            style={{ maxWidth: "400px" }}
            value={replaceEmployeeId}
            onChange={(e) => setReplaceEmployeeId(e.target.value)}
            disabled={!selectedShift}
          >
            <option value="0">Новый сотрудник на смену</option>
            {userModal
              .filter((user) => user.id !== selectedShift?.employee)
              .map((user) => (
                <option key={user.id} value={user.id}>
                  {user.surname} {user.name}
                </option>
              ))}
          </select>
        </div>
      );
    }

    if (graficModalTab === "swap") {
      const swapOptions = getSwapShiftOptions();
      return (
        <div className="schedule-grafic-tab-panel">
          <div className="schedule-chk-modal-info text-center mb-3">
            <p className="mb-1">
              <b>Смена A:</b> {getInfoFromShiftGrafic(selectedShift) || "—"}
            </p>
            <p className="mb-0 small text-muted">{slotInfo}</p>
          </div>
          <select
            className="form-select mx-auto"
            style={{ maxWidth: "420px" }}
            value={swapTemplateShiftId}
            onChange={(e) => setSwapTemplateShiftId(e.target.value)}
            disabled={!selectedShift}
          >
            <option value="0">Смена B для обмена</option>
            {swapOptions.map(({ templateShift, shift }) => (
              <option key={templateShift.id} value={templateShift.id}>
                {shift.user_surname} {shift.user_name} — {templateShift.station_name}{" "}
                ({templateShift.start}-{templateShift.end})
              </option>
            ))}
          </select>
          {selectedShift && swapOptions.length === 0 && (
            <p className="text-muted small text-center mt-2">
              Нет других занятых слотов для обмена в этой неделе
            </p>
          )}
        </div>
      );
    }

    return null;
  }

  function getGraficModalSubmitLabel() {
    if (useServiceNoteFlow) {
      return "Отправить служебную записку";
    }
    if (graficModalTab === "delete") {
      return "Удалить запись";
    }
    return "Записать";
  }

  function isGraficModalSubmitDisabled() {
    if (graficModalTab === "create") {
      return !!selectedShift;
    }
    if (graficModalTab === "delete" || graficModalTab === "replace") {
      return !selectedShift;
    }
    if (graficModalTab === "swap") {
      return !selectedShift || getSwapShiftOptions().length === 0;
    }
    return false;
  }

  async function renderGrafic(data) {
    const templateShifts = data.ts;
    // Все смены ресторана (включая пришедших из других ресторанов) — бэкенд уже
    // фильтрует по restaurant_id; не ограничиваем список «своими» сотрудниками.
    const shifts = data.shifts;
    const info = data.info;
    const ofd = data.ofd;
    let previosNightTS = []; // Шаблоны, которые начинаются и заканчиваются в разный день
    let tables = [];
    let body = [];

    let ts_day_count = 0;
    let ts_day_hours = 0;
    let shifts_day_count = 0;
    let shifts_day_hours = 0;

    let ts_divided = {};
    let shifts_divided = {};
    let ofd_divided = {};

    for (let hour of ofd) {
      const day = new Date(hour.hour).toISOString().split("T")[0];
      if (!ofd_divided[day]) {
        ofd_divided[day] = [];
      }
      ofd_divided[day].push(hour);
    }
    console.log(ofd_divided);

    const date = new Date(arrayDate[0]);
    date.setDate(date.getDate() - 1);
    const previousDay = date.toISOString().split("T")[0]; // '2025-09-14'
    let lastDate = previousDay;

    for (let index in templateShifts) {
      let templateShift = templateShifts[index];
      if (templateShift.date == previousDay) {
        let end = templateShift.end;
        if (end == 0) {
          end = 24;
          if (
            templateShift.start > templateShift.end &&
            templateShift.end > 0
          ) {
            previosNightTS.push(templateShift);
          }
        }

        continue;
      }
      if (templateShift.date in ts_divided) {
        ts_divided[templateShift.date].push(templateShift);
      } else {
        ts_divided[templateShift.date] = [templateShift];
      }
    }

    for (let index in shifts) {
      let shift = shifts[index];
      if (shift.date in shifts_divided) {
        shifts_divided[shift.date].push(shift);
      } else {
        shifts_divided[shift.date] = [shift];
      }
    }

    let has_night_shift_in_last_sunday = false;
    if (has_night_shift_in_last_sunday == false) {
      const orderedDates = Object.keys(ts_divided).sort();
      for (let date of orderedDates) {
        ts_day_count = 0;
        ts_day_hours = 0;
        shifts_day_count = 0;
        shifts_day_hours = 0;

        let startGroup = true;
        body = [];
        let previos_now = previosNightTS;
        previosNightTS = [];
        let previos_ts_sorted = previos_now.sort((a, b) =>
          a.group_station_name.localeCompare(b.group_station_name),
        );
        let previosGrouped = previos_ts_sorted.reduce((groups, ts) => {
          const key = ts.group_station_name;
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(ts);
          return groups;
        }, {});

        for (let group in previosGrouped) {
          previosGrouped[group].sort((a, b) => a.start - b.start);
        }

        let ts_date = ts_divided[date];
        let ord_ts_date = ts_date.sort((a, b) =>
          a.group_station_name.localeCompare(b.group_station_name),
        );
        let grouped = ord_ts_date.reduce((groups, ts) => {
          const key = ts.group_station_name;
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(ts);
          return groups;
        }, {});
        for (let group in grouped) {
          grouped[group].sort((a, b) => a.start - b.start);
        }
        // console.log(previosGrouped, "prev");

        for (let groupName in grouped) {
          let group = grouped[groupName];
          startGroup = true;
          let prevGroup = previosGrouped[groupName];
          if (prevGroup) {
            for (let indexTS in prevGroup) {
              let templateShift = prevGroup[indexTS];
              // ts_day_count += 1;
              // ts_day_hours += templateShift.hours;

              let start = 0;
              let hours = Number(templateShift.end) || 0;
              let end = 24 - hours;
              let shifts = findShift(
                shifts_divided,
                lastDate,
                templateShift.id,
              );

              for (let shift of shifts) {
                let rowspan = prevGroup.length + group.length;
                if (startGroup) {
                  for (let ts of prevGroup) {
                    let shiftsHere = findShift(shifts_divided, lastDate, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                  for (let ts of group) {
                    let shiftsHere = findShift(shifts_divided, date, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                }
                body.push(
                  pushShiftTbody(
                    templateShift,
                    shift,
                    date,
                    startGroup,
                    rowspan,
                    groupName,
                    start,
                    hours,
                    end,
                    "night",
                  ),
                );
                startGroup = false;
              }
              if (shifts.length == 0) {
                let rowspan = prevGroup.length + group.length;
                if (startGroup) {
                  for (let ts of prevGroup) {
                    let shiftsHere = findShift(shifts_divided, lastDate, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                  for (let ts of group) {
                    let shiftsHere = findShift(shifts_divided, date, ts.id);
                    if (shiftsHere.length > 0) {
                      rowspan += shiftsHere.length - 1;
                    }
                  }
                }
                body.push(
                  pushTemplateShiftTbody(
                    templateShift,
                    date,
                    startGroup,
                    rowspan,
                    groupName,
                    start,
                    hours,
                    end,
                    "night",
                  ),
                );
              }
              startGroup = false;
            }
          }

          for (let indexTS in group) {
            let templateShift = group[indexTS];
            let start = Number(templateShift.start) || 0;
            let end = Number(templateShift.end);
            ts_day_hours += templateShift.hours;
            if (end === 0) {
              end = 24;
            }
            let hours = 0;
            if (end > start) {
              hours = end - start;
              end = 24 - end;
            } else if (Number(templateShift.end) > 0) {
              previosNightTS.push(templateShift);
              end = 0;
              hours = 24 - start;
            }

            let shifts = findShift(shifts_divided, date, templateShift.id);
            for (let shift of shifts) {
              if (shift.hours) {
                shifts_day_hours += shift.hours;
              }

              let rowspan = group.length;
              if (startGroup) {
                for (let ts of group) {
                  let shiftsHere = findShift(shifts_divided, date, ts.id);
                  if (shiftsHere.length > 0) {
                    rowspan += shiftsHere.length - 1;
                  }
                }
              }
              body.push(
                pushShiftTbody(
                  templateShift,
                  shift,
                  date,
                  startGroup,
                  rowspan,
                  groupName,
                  start,
                  hours,
                  end,
                  "day",
                ),
              );
              startGroup = false;
            }

            if (shifts.length == 0) {
              let rowspan = group.length;
              if (startGroup) {
                for (let ts of group) {
                  let shiftsHere = findShift(shifts_divided, date, ts.id);
                  if (shiftsHere.length > 0) {
                    rowspan += shiftsHere.length - 1;
                  }
                }
              }
              body.push(
                pushTemplateShiftTbody(
                  templateShift,
                  date,
                  startGroup,
                  // group.length,
                  rowspan,
                  groupName,
                  start,
                  hours,
                  end,
                  "day",
                ),
              );
            }

            startGroup = false;
          }
        }
        let FactSPMH = 0; // TO / hours
        let PlanSPMH = 0; // TO / hours
        let FactTCPH = 0; // receipt / hours
        let PlanTCPH = 0; // receipt / hours
        let receiptsOFD = 0;
        let cashOFD = 0;

        let TOData = null;

        for (let to of info) {
          if (to && to.date == date) {
            console.log(ofd_divided[date]);

            TOData = to;
            if (ts_day_hours > 0) {
              PlanSPMH = (TOData.value / ts_day_hours).toFixed(3);
              PlanTCPH = (TOData.receipt / ts_day_hours).toFixed(3);
            }
            if (shifts_day_hours > 0) {
              FactSPMH = (TOData.value / shifts_day_hours).toFixed(3);
              FactTCPH = (TOData.receipt / shifts_day_hours).toFixed(3);
            }
            break;
          }
        }

        for (let hour in ofd_divided[date]) {
          receiptsOFD += ofd_divided[date][hour].receipts;
          cashOFD += ofd_divided[date][hour].cash;
        }

        if (!TOData) {
          TOData = {};
          TOData.value = "Нет в бд";
          TOData.receipt = "Нет в бд";
        }
        tables.push(
          <div className="table-gragic" key={date}>
            <p className="text-center">
              Дата: {date}. День недели: {getRussianWeekday(date)}.
            </p>
            <div className="table-gragic-kpi">
              <table className="table table-bordered text-center table-sm">
                <thead>
                  <tr>
                    <th></th>
                    <th>ТО</th>
                    <th>Транзакции</th>
                    <th>SPMH</th>
                    <th>TCPH</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>План</td>
                    <td>{TOData.value}</td>
                    <td>{TOData.receipt}</td>
                    <td>{PlanSPMH}</td>
                    <td>{PlanTCPH}</td>
                  </tr>
                  <tr>
                    <td>Факт</td>
                    <td>{cashOFD}</td>
                    <td>{receiptsOFD}</td>
                    <td>{FactSPMH}</td>
                    <td>{FactTCPH}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* <table className="table table-bordered table-striped"> */}
            <div className="table-responsive">
            <table className="table table-bordered text-center grafic-table schedule-chk-table">
              <thead>
                <tr>
                  <th scope="col">Группа</th>
                  <th scope="col">Позиция</th>
                  <th scope="col">Сотрудник</th>
                  <th scope="col">С По</th>
                  {/* Добавляем заголовки от 0 до 23 */}
                  {Array.from({ length: 24 }, (_, i) => (
                    <th key={i} className="text-center grafic-hour" scope="col">
                      {i}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>{body}</tbody>
            </table>
            </div>
          </div>,
        );
        lastDate = date;
      }
    }

    setGraficSchedulTables(tables);
  }

  function findShift(shfits, date, templateShiftId) {
    const shifts = shfits[date];
    let needShifts = [];
    if (!shifts) return [];
    for (let shift of shifts) {
      if (shift.template_shift_id == templateShiftId) {
        needShifts.push(shift);
      }
    }
    return needShifts;
  }

  function getInfoShiftGrafic(shift) {
    if (shift) {
      return `${shift.start} - ${shift.end} ${shift.station_name} ${
        shift.date
      }. ${getRussianWeekday(shift.date)}. В ресторане ${shift.restaurant_name}`;
    }
  }

  function getInfoTemplateShiftGrafic(templateShift) {
    console.log(templateShift, "выбранный шаблон смены");
    if (templateShift) {
      return `${templateShift.start} - ${templateShift.end} ${
        templateShift.station_name
      } ${templateShift.date}. ${getRussianWeekday(templateShift.date)}`;
    }
  }

  function getInfoFromShiftGrafic(shift) {
    if (shift) {
      // return `${shift.user_surname} ${shift.user_name} ${shift.user_post_name}`;
      return `${shift.user_surname} ${shift.user_name}. `;
    }
  }

  async function loadAppored(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) return;
    if (!overrideFrom && isLoadingApprove) return;
    setIsLoadingApprove(true);
    try {
      const data = await GetApprove(token, from, to);
      if (!Number.isFinite(data?.id)) {
        setDataApprove(null);
        return;
      }
      setDataApprove(data);
    } catch (err) {
      console.error(err);
      setDataApprove(null);
    } finally {
      setIsLoadingApprove(false);
    }
  }

  async function loadScheduleAboutShfit(overrideFrom, overrideTo) {
    const from = overrideFrom ?? arrayDate[0];
    const to = overrideTo ?? arrayDate.at(-1);
    if (!from) return;
    if (!overrideFrom && isLoadingSummary) return;
    setIsLoadingSummary(true);
    try {
      const data = await GetScheduleAboutShifts(token, from, to);
      setDataAboutShift(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSummary(false);
    }
  }

  async function getFreeTSForDay(week) {
    if (!currentUser?.restaurant_id) return;
    const freeTSForDay = await FreeTS(
      token,
      currentUser.restaurant_id,
      arrayDate[week],
    );
    setDataFreeTS(freeTSForDay);
  }

  async function createShiftDayByTS(params) {
    if (parseInt(selectedFreeTS) === 0) {
      setModalMessageDay(
        <p style={{ color: "red" }}> Не выбран шаблон смены для сотрудника</p>,
      );
      return;
    }
    console.log(selectedFreeTS, selectedDayUser);
    const newShift = await addShift(token, selectedFreeTS, selectedDayUser.id);
    if (newShift.detail) {
      setModalMessageDay(<p style={{ color: "red" }}>{newShift.detail}</p>);
      return;
    }
    const updateDataScheduleDays = dataScheduleDays.map((userShifts) => {
      const user = userShifts[7]; // Получаем объект пользователя
      if (user.id === selectedDayUser.id) {
        // Создаем копию всего массива смен пользователя
        const newUserShifts = [...userShifts];

        // Получаем массив смен для выбранного дня (если он есть)
        const existingShifts = newUserShifts[selectedWeekday] || [];

        // Создаем НОВЫЙ массив смен: старые + новая смена
        newUserShifts[selectedWeekday] = [
          ...existingShifts, // Все существующие смены этого дня
          newShift, // Добавляем новую смену
        ];

        return newUserShifts;
      }
      return [...userShifts];
    });
    setDataScheduleDays(updateDataScheduleDays);

    if (dataGraficSchedule) {
      // 1. Создаем новый массив с добавленной сменой
      const updatedShifts = [...dataGraficSchedule.shifts, newShift];

      // 2. Создаем новый объект с обновленным массивом
      const updatedSchedule = {
        ...dataGraficSchedule,
        shifts: updatedShifts,
      };

      // 3. Обновляем состояние
      setDataGraficSchedule(updatedSchedule);

      // 4. Перерисовываем график с новыми данными
      renderGrafic(updatedSchedule);
    }

    if (dataAboutShift) {
      const updatedData = {
        ...dataAboutShift, // Копируем все существующие поля
        shifts: [...dataAboutShift.shifts, newShift], // Создаем новый массив смен
      };
      setDataAboutShift(updatedData);
    }

    setModalMessageDay(<p style={{ color: "green" }}> Успешно!</p>);
    setSelectedFreeTS(0);
    setSelectedShiftDay(newShift);
    const newDataTS = dataFreeTS.filter(
      (ts) => ts.id !== newShift.template_shift_id,
    );

    setDataFreeTS(newDataTS);
    setShowAddFromDay(false);
    // console.log(dataFreeTS.filter)
  }

  const renderLoading = () => (
    <div className="schedule-chk-loading">
      <div className="spinner-border profile-spinner" role="status">
        <span className="visually-hidden">Загрузка...</span>
      </div>
      <p>Загрузка расписания...</p>
    </div>
  );

  const weekLabel =
    startDate && endDate
      ? `${formatShortDate(startDate)} — ${formatShortDate(endDate)}`
      : "";

  return (
    <div className="schedule-chk-page">
      <div className="schedule-chk-toolbar">
        <div>
          <h1>Расписание ЧК</h1>
          <p className="schedule-chk-hint">
            Выберите любой день — загрузится неделя с понедельника по воскресенье
          </p>
        </div>
        <div className="schedule-chk-toolbar-right">
          <div className="schedule-chk-week-picker">
            <label className="schedule-chk-week-label" htmlFor="chk-week-date">
              Неделя
            </label>
            <input
              id="chk-week-date"
              type="date"
              className="form-control"
              value={weekPickerDate}
              onChange={selectDateDay}
            />
            <span className="schedule-chk-week-range">{weekLabel}</span>
          </div>
          <Link to="/profile" className="schedule-chk-back-link">
            ← К профилю
          </Link>
        </div>
      </div>

      <div className="schedule-chk-tabs-wrap">
        <ul className="nav nav-tabs schedule-chk-tabs">
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "days" ? "active" : ""}`}
              onClick={() => switchTab("days")}
            >
              По дням
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "grafic" ? "active" : ""}`}
              onClick={() => switchTab("grafic")}
            >
              График
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "summary" ? "active" : ""}`}
              onClick={() => switchTab("summary")}
            >
              Сводка
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "approve" ? "active" : ""}`}
              onClick={() => switchTab("approve")}
            >
              Согласование
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === "more" ? "active" : ""}`}
              onClick={() => switchTab("more")}
            >
              Прочее
            </button>
          </li>
        </ul>
      </div>

      <div className="schedule-chk-panel">
        {activeTab === "days" && (
          <>
            {isLoadingDays ? (
              renderLoading()
            ) : getDaysRows(dataScheduleDays).length === 0 ? (
              <div className="schedule-chk-empty">
                Нет данных за выбранную неделю
              </div>
            ) : (
              <>
                <div className="schedule-chk-legend">
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--off" />
                    Выходной
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--regular" />
                    Смена
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--intern" />
                    Закрепление
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--foreign" />
                    Другой ресторан
                  </span>
                  <span className="schedule-chk-legend-item">
                    <span className="schedule-chk-legend-swatch shift-cell--open" />
                    Статус дня
                  </span>
                </div>
                <div
                  className={`schedule-mng-workspace${
                    selectMode ? " is-selecting" : ""
                  }`}
                >
                  {canManageSchedule ? (
                    <ScheduleSelectDock active={selectMode}>
                    <div
                      className={`schedule-mng-select-bar${
                        selectMode ? " is-active" : ""
                      }`}
                    >
                      <div className="schedule-mng-select-copy">
                        <strong>
                          {selectMode
                            ? Object.keys(selectedShifts).length
                              ? `Выбрано ${Object.keys(selectedShifts).length}`
                              : "Выделите смены"
                            : "Несколько смен"}
                        </strong>
                        <p>
                          {selectMode
                            ? "Клик по смене — выбрать. По дате или ФИО — все доступные. Прошедшие даты не берутся."
                            : "Включите выделение, отметьте ячейки и удалите сразу несколько смен."}
                        </p>
                      </div>
                      <div className="schedule-mng-select-actions">
                        {selectMode ? (
                          <>
                            <button
                              type="button"
                              className="schedule-chk-week-tool-btn"
                              onClick={clearSelection}
                              disabled={Object.keys(selectedShifts).length === 0}
                            >
                              Снять
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => setConfirmBulkDelete(true)}
                              disabled={
                                Object.keys(selectedShifts).length === 0 ||
                                bulkDeleting
                              }
                            >
                              Удалить
                              {Object.keys(selectedShifts).length
                                ? ` ${Object.keys(selectedShifts).length}`
                                : ""}
                            </button>
                            <button
                              type="button"
                              className="schedule-chk-week-tool-btn"
                              onClick={toggleSelectMode}
                            >
                              Готово
                            </button>
                          </>
                        ) : (
                          <button
                            type="button"
                            className="btn"
                            onClick={toggleSelectMode}
                          >
                            Выделить
                          </button>
                        )}
                      </div>
                      {bulkMessage ? (
                        <p
                          className={`schedule-mng-select-message ${
                            bulkMessage.ok ? "is-ok" : "is-error"
                          }`}
                        >
                          {bulkMessage.text}
                        </p>
                      ) : null}
                    </div>
                    </ScheduleSelectDock>
                  ) : null}
                  <div className="table-responsive schedule-chk-table-wrap">
                    <table className="table table-bordered table-hover schedule-chk-table">
                      <thead>
                        <tr>
                          <th
                            className="text-center schedule-chk-sticky-col"
                            scope="col"
                          >
                            Сотрудник
                          </th>
                          {DAY_LABELS.map((label, i) => (
                            <th
                              key={label}
                              className={`text-center${
                                selectMode ? " schedule-mng-select-head" : ""
                              }`}
                              scope="col"
                              title={
                                selectMode
                                  ? "Выделить все смены этого дня"
                                  : undefined
                              }
                              onClick={
                                selectMode
                                  ? () => toggleDayColumn(i)
                                  : undefined
                              }
                            >
                              {label}
                              {arrayDate[i] && (
                                <span className="day-header-date">
                                  {formatShortDate(arrayDate[i])}
                                </span>
                              )}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>{getDaysRows(dataScheduleDays)}</tbody>
                    </table>
                  </div>
                  {confirmBulkDelete ? (
                    <div className="schedule-chk-week-modal">
                      <div className="schedule-chk-week-modal-card">
                        <h5>Удалить выбранные смены?</h5>
                        <p>
                          Будет удалено {Object.keys(selectedShifts).length}{" "}
                          {Object.keys(selectedShifts).length === 1
                            ? "смена"
                            : "смен"}
                          . Прошедшие даты сервер пропустит. Если за сотрудником
                          есть стажёры, эту смену нужно удалить вместе с ними.
                        </p>
                        <div className="schedule-chk-week-modal-actions">
                          <button
                            type="button"
                            className="schedule-chk-week-tool-btn"
                            onClick={() => setConfirmBulkDelete(false)}
                            disabled={bulkDeleting}
                          >
                            Отмена
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={deleteSelectedShifts}
                            disabled={bulkDeleting}
                          >
                            {bulkDeleting ? "Удаление…" : "Удалить"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </>
            )}
          </>
        )}

        {activeTab === "grafic" && (
          <>
            <div className="schedule-chk-view-toggle">
              <button
                type="button"
                className={`schedule-chk-view-btn ${
                  graficViewMode === "employees" ? "is-active" : ""
                }`}
                onClick={() => setGraficViewMode("employees")}
              >
                По сотрудникам
              </button>
              <button
                type="button"
                className={`schedule-chk-view-btn ${
                  graficViewMode === "employeeWeek" ? "is-active" : ""
                }`}
                onClick={() => setGraficViewMode("employeeWeek")}
              >
                Сотрудники × неделя
              </button>
              <button
                type="button"
                className={`schedule-chk-view-btn ${
                  graficViewMode === "stations" ? "is-active" : ""
                }`}
                onClick={() => setGraficViewMode("stations")}
              >
                По станциям
              </button>
            </div>

            {isLoadingGrafic ? (
              renderLoading()
            ) : graficViewMode === "employees" ? (
              dataGraficSchedule ? (
                <ScheduleChkEmployeeTimeline
                  schedule={dataGraficSchedule}
                  weekDates={arrayDate}
                />
              ) : (
                <div className="schedule-chk-empty">
                  Нет графика за выбранную неделю
                </div>
              )
            ) : graficViewMode === "employeeWeek" ? (
              dataGraficSchedule ? (
                <div
                  ref={weekWorkspaceRef}
                  className={`schedule-chk-week-workspace ${
                    weekFullscreen ? "is-fullscreen" : ""
                  }`}
                >
                  <div className="schedule-chk-week-toolbar">
                    {canManageSchedule && (
                      <button
                        type="button"
                        className="schedule-chk-week-tool-btn"
                        onClick={() =>
                          setWeekTemplatePanelOpen((open) => !open)
                        }
                      >
                        {weekTemplatePanelOpen
                          ? "Скрыть шаблоны"
                          : "Показать шаблоны"}
                      </button>
                    )}
                    <button
                      type="button"
                      className="schedule-chk-week-tool-btn is-primary"
                      onClick={toggleWeekFullscreen}
                    >
                      {weekFullscreen ? "Свернуть экран" : "На весь экран"}
                    </button>
                  </div>
                  <div
                    className={`schedule-chk-assign-layout ${
                      weekTemplatePanelOpen ? "" : "is-panel-collapsed"
                    }`}
                  >
                    {canManageSchedule && weekTemplatePanelOpen && (
                      <ScheduleChkTemplateAssignPanel
                        templates={dataGraficSchedule.ts || []}
                        shifts={dataGraficSchedule.shifts || []}
                        weekDates={arrayDate}
                        selectedTemplateId={selectedDirectorTemplateId}
                        onSelect={(id) => {
                          setSelectedDirectorTemplateId(id);
                          setAssignMessage(null);
                          setWeekReplacePrompt(null);
                        }}
                        filledCount={directorAssignStats.filledCount}
                        slotCount={directorAssignStats.slotCount}
                        disabled={useServiceNoteFlow}
                        message={assignMessage}
                        onCollapse={() => setWeekTemplatePanelOpen(false)}
                      />
                    )}
                    {canManageSchedule && !weekTemplatePanelOpen && (
                      <button
                        type="button"
                        className="schedule-chk-panel-rail"
                        onClick={() => setWeekTemplatePanelOpen(true)}
                      >
                        Шаблоны
                      </button>
                    )}
                    <div className="schedule-chk-assign-board">
                      <ScheduleChkEmployeeWeek
                        schedule={dataGraficSchedule}
                        weekDates={arrayDate}
                        employees={userModal}
                        selectedTemplate={
                          (dataGraficSchedule.ts || []).find(
                            (ts) =>
                              Number(ts.id) ===
                              Number(selectedDirectorTemplateId),
                          ) || null
                        }
                        canAssign={canManageSchedule && !useServiceNoteFlow}
                        hoursByEmployee={directorAssignStats.hoursByEmployee}
                        onEmployeeClick={handleWeekEmployeeClick}
                        onShiftClick={handleWeekShiftClick}
                      />
                    </div>
                  </div>
                  {weekReplacePrompt && (
                    <div
                      className="schedule-chk-week-modal"
                      onClick={() => setWeekReplacePrompt(null)}
                    >
                      <div
                        className="schedule-chk-week-modal-card"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="week-replace-title"
                        onClick={(event) => event.stopPropagation()}
                      >
                        <h5 id="week-replace-title">Замена сотрудника</h5>
                        <p>
                          {weekReplacePrompt.occupiedName
                            ? `Слот уже занят: ${weekReplacePrompt.occupiedName}. Поставить ${weekReplacePrompt.employeeName}?`
                            : `Поставить ${weekReplacePrompt.employeeName} на этот шаблон?`}
                        </p>
                        <div className="schedule-chk-week-modal-actions">
                          <button
                            type="button"
                            className="schedule-chk-week-tool-btn"
                            onClick={() => setWeekReplacePrompt(null)}
                          >
                            Отмена
                          </button>
                          <button
                            type="button"
                            className="schedule-chk-week-tool-btn is-primary"
                            onClick={confirmWeekReplace}
                          >
                            Заменить
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="schedule-chk-empty">
                  Нет графика за выбранную неделю
                </div>
              )
            ) : graficScheduleTables.length === 0 ? (
              <div className="schedule-chk-empty">
                Нет графика за выбранную неделю
              </div>
            ) : (
              <div className="schedule-chk-assign-layout">
                {canManageSchedule && (
                  <ScheduleChkDirectorAssignPanel
                    employees={userModal}
                    hoursByEmployee={directorAssignStats.hoursByEmployee}
                    ftIds={directorAssignStats.ftIds}
                    selectedEmployeeId={selectedDirectorEmployeeId}
                    onSelect={(id) => {
                      setSelectedDirectorEmployeeId(id);
                      setAssignMessage(null);
                    }}
                    filledCount={directorAssignStats.filledCount}
                    slotCount={directorAssignStats.slotCount}
                    disabled={useServiceNoteFlow}
                    message={assignMessage}
                  />
                )}
                <div
                  ref={graficBoardRef}
                  className={`schedule-chk-assign-board ${
                    selectedDirectorEmployeeId ? "is-filtering" : ""
                  }`}
                  data-highlight-id={selectedDirectorEmployeeId || ""}
                >
                  {graficScheduleTables.map((table) => table)}
                </div>
              </div>
            )}
          </>
        )}

        {activeTab === "summary" && (
          <>
            {isLoadingSummary ? (
              renderLoading()
            ) : !dataAboutShift ? (
              <div className="schedule-chk-empty">
                Нет сводки за выбранную неделю
              </div>
            ) : (
              <ScheduleChkSummary
                data={dataAboutShift}
                restaurantId={currentUser?.restaurant_id}
                userModal={userModal}
                dataScheduleDays={dataScheduleDays}
                weekDates={arrayDate}
              />
            )}
          </>
        )}

        {activeTab === "approve" && (
          <>
            {isLoadingApprove && !Number.isFinite(dataApprove?.id) ? (
              renderLoading()
            ) : !Number.isFinite(dataApprove?.id) ? (
              <div className="schedule-chk-empty">
                Нет данных о согласовании за выбранную неделю
              </div>
            ) : (
              <ScheduleChkApprove
                data={dataApprove}
                weekDates={arrayDate}
                accessLevel={accessLevelNow}
                token={token}
                onUpdated={setDataApprove}
              />
            )}
          </>
        )}

        {activeTab === "more" && (
          <ScheduleChkMore
            token={token}
            restaurants={restaurants}
            employees={userModal}
            currentRestaurantId={currentUser?.restaurant_id}
            weekDates={arrayDate}
            accessLevel={accessLevelNow}
          />
        )}

      </div>

      <div className="row">
        <div className="col-md-12">
        <div
          className="modal fade modal-schedule-chk-day schedule-mng-modal"
          id="ScheduleDayModal"
          tabIndex="-1"
          aria-labelledby="approvalModelLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered schedule-mng-create-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <p className="schedule-mng-modal-kicker">
                    {showAddFromDay ? "Новая запись" : "Расписание ЧК"}
                  </p>
                  <h5 className="modal-title" id="approvalModelLabel">
                    {showAddFromDay
                      ? dayModalTab === "intern"
                        ? "Закрепление на период"
                        : "Статус на период"
                      : "Смена"}
                  </h5>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Закрыть"
                />
              </div>
              <div className="modal-body">
                {(() => {
                  const endDate = dayModalEndDate || dayModalStartDate;
                  const isRange = Boolean(
                    endDate && dayModalStartDate && endDate !== dayModalStartDate,
                  );
                  const dateLabel = isRange
                    ? `${formatShortDate(dayModalStartDate)} — ${formatShortDate(endDate)}`
                    : formatShortDate(
                        dayModalStartDate || arrayDate[selectedWeekday],
                      );
                  const statusPreview = getStatusRangePreview();
                  const internPreview = getInternRangePreview();
                  const emptyDayFact = showAddFromDay
                    ? renderDayFactDetail()
                    : null;
                  return (
                    <>
                      {renderDayPersonCard(dateLabel)}
                      <p className="schedule-mng-modal-date">
                        {weekDays[selectedWeekday]
                          ? `${weekDays[selectedWeekday]}, ${formatChkDisplayDate(
                              dayModalStartDate || arrayDate[selectedWeekday],
                            )}`
                          : formatChkDisplayDate(
                              dayModalStartDate || arrayDate[selectedWeekday],
                            )}
                      </p>
                      {emptyDayFact ? (
                        <div className="schedule-mng-details">
                          {emptyDayFact}
                        </div>
                      ) : null}
                      {showAddFromDay ? (
                        <>
                          <div className="schedule-mng-mode" role="tablist">
                            <button
                              type="button"
                              className={
                                dayModalTab === "status" ? "is-active" : ""
                              }
                              onClick={() => setDayModalTab("status")}
                            >
                              Статус
                            </button>
                            <button
                              type="button"
                              className={
                                dayModalTab === "intern" ? "is-active" : ""
                              }
                              onClick={() => setDayModalTab("intern")}
                            >
                              Закрепить
                            </button>
                          </div>
                          {dayModalTab === "status" ? (
                            <>
                              <div className="schedule-mng-field">
                                <label
                                  className="form-label"
                                  htmlFor="chk-day-status"
                                >
                                  Какой статус
                                </label>
                                <select
                                  id="chk-day-status"
                                  className="form-select"
                                  value={selectedTypeShift || 0}
                                  onChange={(e) =>
                                    setSelectedTypeShift(e.target.value)
                                  }
                                >
                                  <option value="0">Выберите статус дня</option>
                                  {openTypeShift.map((typeShift) => (
                                    <option
                                      key={typeShift.id}
                                      value={typeShift.id}
                                    >
                                      {typeShift.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              {renderDayRangeFields(statusPreview)}
                            </>
                          ) : (
                            <>
                              <div className="schedule-mng-field">
                                <label
                                  className="form-label"
                                  htmlFor="chk-day-intern"
                                >
                                  За кем закрепить
                                </label>
                                <select
                                  id="chk-day-intern"
                                  className="form-select"
                                  value={selectedInternUser || 0}
                                  onChange={(e) =>
                                    setSelectedInternUser(e.target.value)
                                  }
                                >
                                  <option value="0">
                                    Выберите сотрудника
                                  </option>
                                  {userModal
                                    .filter(
                                      (user) =>
                                        user.id !== selectedDayUser?.id,
                                    )
                                    .map((user) => (
                                      <option key={user.id} value={user.id}>
                                        {user.surname} {user.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              {renderDayRangeFields(internPreview)}
                            </>
                          )}
                          {renderDayTemplateField()}
                        </>
                      ) : (
                        <>
                          {renderDayShiftDetails(selectedShiftDay)}
                          {renderDayTemplateField()}
                        </>
                      )}
                      {modalMessageDay ? (
                        <div className="schedule-mng-modal-message">
                          {modalMessageDay}
                        </div>
                      ) : null}
                    </>
                  );
                })()}
              </div>
              <div className="modal-footer">
                {showAddFromDay ? (
                  <>
                    <button
                      type="button"
                      className="schedule-chk-week-tool-btn"
                      data-bs-dismiss="modal"
                    >
                      Отмена
                    </button>
                    <button
                      type="button"
                      className="btn"
                      onClick={
                        dayModalTab === "intern"
                          ? addInternShiftScheduleDay
                          : addShiftOpenScheduleDay
                      }
                      disabled={dayModalCreating}
                    >
                      {getCreateButtonLabel(
                        dayModalTab === "intern"
                          ? getInternRangePreview()
                          : getStatusRangePreview(),
                      )}
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="schedule-chk-week-tool-btn"
                      data-bs-dismiss="modal"
                    >
                      Закрыть
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={deleteShiftScheduleChk}
                    >
                      Удалить
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade modal-schedule-chk-day schedule-grafic-modal"
          id="ScheduleGraficModal"
          tabIndex="-1"
          aria-labelledby="ScheduleGraficModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header justify-content-center flex-column border-0 pb-0">
                <h1 className="modal-title fs-5" id="ScheduleGraficModalLabel">
                  {useServiceNoteFlow
                    ? "Служебная записка — изменение расписания"
                    : "Работа со сменой"}
                </h1>
                {useServiceNoteFlow && (
                  <p className="small text-muted mb-0 mt-1 text-center">
                    Расписание согласовано ТУ. Изменения оформляются через
                    служебную записку.
                  </p>
                )}
              </div>
              <div className="modal-body pt-2">
                <ul
                  className="nav nav-tabs schedule-grafic-modal-tabs mb-3"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "create" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("create")}
                    >
                      Запись на смену
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "delete" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("delete")}
                    >
                      Удаление
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "replace" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("replace")}
                      disabled={!useServiceNoteFlow && !selectedShift}
                    >
                      Заменить сотрудника
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      type="button"
                      className={`nav-link ${graficModalTab === "swap" ? "active" : ""}`}
                      onClick={() => setGraficModalTab("swap")}
                      disabled={!useServiceNoteFlow && !selectedShift}
                    >
                      Поменять местами
                    </button>
                  </li>
                </ul>
                {renderGraficModalTabContent()}
                {useServiceNoteFlow && (
                  <div className="mt-3">
                    <label className="form-label small fw-semibold">
                      Причина / комментарий к служебной записке
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={serviceNoteComment}
                      onChange={(e) => setServiceNoteComment(e.target.value)}
                      placeholder="Опишите причину изменения расписания"
                    />
                  </div>
                )}
              </div>
              <div className="modal-footer justify-content-center flex-column border-0 pt-0">
                {((graficModalTab === "create" ||
                  graficModalTab === "delete") ||
                  useServiceNoteFlow) && (
                  <button
                    type="button"
                    className={`btn mb-2 ${graficModalTab === "delete" && !useServiceNoteFlow ? "btn-danger" : ""}`}
                    onClick={handleGraficModalSubmit}
                    disabled={isGraficModalSubmitDisabled()}
                  >
                    {getGraficModalSubmitLabel()}
                  </button>
                )}
                {!useServiceNoteFlow &&
                  (graficModalTab === "replace" || graficModalTab === "swap") && (
                    <p className="text-muted small text-center mb-2">
                      Замена и обмен сотрудников — через служебную записку после
                      согласования расписания ТУ
                    </p>
                  )}
                <div className="text-center w-100">{modalMessageGrafic}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
  function pushTemplateShiftTbody(
    templateShift,
    date,
    startGroup,
    offset,
    groupName,
    start,
    hours,
    end,
    keyText,
  ) {
    return (
      <tr
        key={`ts_${templateShift.id}_${keyText}`}
        data-empty="true"
        onClick={() => handleStationSlotClick(templateShift, null, date)}
      >
        {startGroup && (
          <td rowSpan={offset} className="align-items-center">
            {groupName}
          </td>
        )}
        <td>{templateShift.station_name}</td>
        <td className="text-center">Не выбрано</td>
        <td className="text-center">
          {templateShift.start} - {templateShift.end}
        </td>
        {renderGraficHourCells(start, hours, end, false)}
      </tr>
    );
  }

  function pushShiftTbody(
    templateShift,
    shift,
    date,
    startGroup,
    offset,
    groupName,
    start,
    hours,
    end,
    KeyText,
  ) {
    return (
      <tr
        key={`shift_${shift.id}_${KeyText}`}
        data-employee-id={shift.employee}
        className={
          selectedDirectorEmployeeId != null &&
          Number(shift.employee) === Number(selectedDirectorEmployeeId)
            ? "is-selected-employee"
            : ""
        }
        onClick={() => handleStationSlotClick(templateShift, shift, date)}
      >
        {startGroup && (
          <td rowSpan={offset} className="align-items-center">
            {groupName}
          </td>
        )}
        <td>{templateShift.station_name}</td>
        <td className="text-center">
          {shift.user_surname} {shift.user_name} {shift.user_post_name}
        </td>
        <td className="text-center">
          {shift.start} - {shift.end}
        </td>
        {renderGraficHourCells(start, hours, end, true)}
      </tr>
    );
  }
};

export default ScheduleChk;

const formatDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function getFormattedWeekDates(inputDate) {
  // Создаем копию объекта Date, чтобы не изменять оригинал
  const date = new Date(inputDate);

  // Получаем день недели (0 - воскресенье, 1 - понедельник и т.д.)
  const dayOfWeek = date.getDay();

  // Вычисляем дату понедельника
  const monday = new Date(date);
  monday.setDate(date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  // Создаем массив отформатированных дат
  const weekDates = [];

  // Добавляем 7 дней (с понедельника по воскресенье)
  for (let i = 0; i < 7; i++) {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    weekDates.push(formatDate(day));
  }

  return weekDates;
}

function getWeekRange(inputDate) {
  // Создаем копию входной даты, чтобы не изменять оригинал
  const date = new Date(inputDate);

  // Получаем день недели (0 - воскресенье, 1 - понедельник, ..., 6 - суббота)
  const dayOfWeek = date.getDay();

  // Вычисляем разницу между текущим днем и понедельником
  // Если день воскресенье (0), то понедельник был 6 дней назад
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

  // Вычисляем дату понедельника
  const monday = new Date(date);
  monday.setDate(date.getDate() + diffToMonday);

  // Вычисляем дату воскресенья (понедельник + 6 дней)
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const lastSunday = new Date(monday);
  lastSunday.setDate(monday.getDate() - 1);

  // Возвращаем объект с датами
  return {
    monday: formatDate(monday),
    sunday: formatDate(sunday),
    lastSunday: formatDate(lastSunday),
  };
}

const weekDays = {
  0: "Понедельник",
  1: "Вторник",
  2: "Среда",
  3: "Четверг",
  4: "Пятница",
  5: "Суббота",
  6: "Воскресенье",
};

function formatShortDate(dateString) {
  if (!dateString) return "";
  const iso = String(dateString).slice(0, 10);
  const parts = iso.split("-");
  return parts[2] && parts[1] ? `${parts[2]}.${parts[1]}` : iso;
}

function toIsoDate(value) {
  if (!value) return "";
  if (typeof value === "string") return value.slice(0, 10);
  try {
    return formatDate(new Date(value));
  } catch (err) {
    return "";
  }
}

function parseIso(iso) {
  if (!iso) return null;
  const [year, month, day] = String(iso).slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return null;
  return { year, month: month - 1, day };
}

function addDaysIso(iso, days) {
  const parsed = parseIso(iso);
  if (!parsed) return iso;
  const date = new Date(parsed.year, parsed.month, parsed.day);
  date.setDate(date.getDate() + days);
  return formatDate(date);
}

function eachIsoDate(startIso, endIso) {
  const start = parseIso(startIso);
  const end = parseIso(endIso);
  if (!start || !end) return [];
  const dates = [];
  const cursor = new Date(start.year, start.month, start.day);
  const last = new Date(end.year, end.month, end.day);
  if (last < cursor) return [];
  while (cursor <= last) {
    dates.push(formatDate(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return dates;
}

function todayLocalIso() {
  return formatDate(new Date());
}

function weekSundayIso(iso) {
  const parsed = parseIso(iso);
  if (!parsed) return iso;
  const date = new Date(parsed.year, parsed.month, parsed.day);
  const day = date.getDay();
  const diff = day === 0 ? 0 : 7 - day;
  date.setDate(date.getDate() + diff);
  return formatDate(date);
}

function personInitials(user) {
  const surname = String(user?.surname || "").trim();
  const name = String(user?.name || "").trim();
  return `${surname.charAt(0)}${name.charAt(0)}`.toUpperCase() || "?";
}

function formatChkDisplayDate(dateString) {
  if (!dateString) return "—";
  const iso = String(dateString).slice(0, 10);
  const parsed = parseIso(iso);
  if (!parsed) return iso;
  const date = new Date(parsed.year, parsed.month, parsed.day);
  const weekdays = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  const day = String(parsed.day).padStart(2, "0");
  const month = String(parsed.month + 1).padStart(2, "0");
  return `${day}.${month}.${parsed.year} (${weekdays[date.getDay()]})`;
}

function errorText(payload, fallback) {
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;
  if (typeof payload.detail === "string") return payload.detail;
  if (Array.isArray(payload.detail) && payload.detail[0]?.msg) {
    return payload.detail[0].msg;
  }
  return fallback;
}

function getInfoUser(user) {
  return `${user.surname} ${user.name} \n (${user.post_name})`;
}

function getInfoShift(shift) {
  if (shift) {
    if (shift.type_shift_id == 2) {
      return `Закр. за сот. ${shift.start} - ${shift.end} ${shift.station_name}`;
    } else if (shift.hours) {
      return `${shift.start} - ${shift.end} ${shift.station_name}`;
    } else {
      return `${shift.type_shift_name}`;
    }
  }
}

function getRussianWeekday(dateString) {
  const date = new Date(dateString);
  const days = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  return days[date.getDay()];
}

function renderGraficHourCells(start, hours, end, filled) {
  const before = Math.max(0, Math.round(Number(start) || 0));
  const span = Math.max(0, Math.round(Number(hours) || 0));
  let after = Math.max(0, Math.round(Number(end) || 0));
  if (before + span + after !== 24) {
    after = Math.max(0, 24 - before - span);
  }
  const spanClass = filled
    ? "grafic-hour grafic-hour--filled"
    : "grafic-hour grafic-hour--empty";
  return [
    ...Array.from({ length: before }, (_, i) => (
      <td key={`before-${i}`} className="grafic-hour" />
    )),
    ...Array.from({ length: span }, (_, i) => (
      <td key={`span-${i}`} className={spanClass} />
    )),
    ...Array.from({ length: after }, (_, i) => (
      <td key={`after-${i}`} className="grafic-hour" />
    )),
  ];
}

function getISODayNumber(dateString) {
  const date = new Date(dateString);
  const dayNumber = date.getDay(); // 0=воскресенье, 1=понедельник... 6=суббота

  // Преобразуем: понедельник=0, воскресенье=6
  return dayNumber === 0 ? 6 : dayNumber - 1;
}
